<template>
  <div class="green lighten-4 inp font-weight-medium">
    <a style="position:absolute; right: 20px">
      <v-icon v-if="!hideSave" @click="$emit('save')">mdi-content-save</v-icon>

      <v-btn
        v-if="showMenu"
        @click="menuItemClicked"
        icon
        aria-label="body menu"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!--      <v-icon @click="selectAll">mdi-select-all</v-icon>-->
    </a>

    <editor-content
      ref="editor"
      style="text-align: start; margin-right: 50px"
      :editor="editor"
    />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Placeholder from '@tiptap/extension-placeholder'

export default {
  components: {
    EditorContent
  },

  props: {
    value: {
      type: String,
      default: ''
    },
    clear: Boolean,
    hideSave: Boolean,
    showMenu: Boolean
  },

  data() {
    return {
      editor: null,
      items: [this.$t('save_response'), this.$t('clear_text')],
      itemsEvents: ['New', 'Clear']
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = this.editor.getJSON().toString() === value.toString()

      if (isSame) {
        return
      }

      this.editor.commands.setContent(this.value, false)
    }
  },

  mounted() {
    this.editor = new Editor({
      extensions: [StarterKit, Link, Placeholder],
      content: this.value,
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      }
    })
  },
  methods: {
    menuItemClicked() {
      this.$emit('menu', 'Clear')
      // this.editor.commands.clearContent()
      this.editor.commands.focus()
    },
    selectAll() {
      this.editor.commands.selectAll()
    }
  },

  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>
<style>
.ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #ced4da;
  pointer-events: none;
  height: 0;
}
.inp {
  padding: 2px 10px 10px;
  margin: 4px 4px 4px 4px;
  border: none;
  border-radius: 4px;
  outline: 0;
}
</style>
